//import { $sxhr } from "../../stempcore";
//import { sxhr } from "fire-wind-water/sxhr";
//import { from, of } from "rxjs";
//import { mergeMap } from "rxjs/operators";
import URL from "../assets/conf/setting.json";

// 文件图片上传用到
const apiUrl = URL.template.api.gateway.general;
const sbaseUrl = URL.sbaseUrl;
window.$sk.setApiUrl(apiUrl);
window.$sk.setUploadUrl(sbaseUrl);

//const staticRequest = function (url, info, conf) {
//  // 存在静态化配置，优先获取静态连接，如不存在，走API请求
//  var staticUrl = window.staticReqMapping
//    ? window.staticReqMapping.getStaticUrl(url, info)
//    : "";
//  // console.log('########################################');
//  // console.log(url, staticUrl);
//  const params = { ...info, ...cacheWithParams };
//  if (staticUrl) {
//    return from(
//      // 利用from操作符将Promise转为Observable
//      // 请求静态地址(url上需要添加随机数，以保证数据为最新)
//      sxhr
//        .get(staticUrl + "?time_stamp=" + new Date().getTime(), info, conf)
//        .then(
//          (res) => {
//            return res.data.body;
//          },
//          () => {
//            return null; // 静态json错误，返回null
//          }
//        )
//    ).pipe(
//      mergeMap((body) => {
//        if (body) {
//          return of(body);
//        } else {
//          // 静态json出错，转为API请求
//          return $sxhr.post(url, params, conf);
//        }
//      })
//    );
//  } else {
//    return $sxhr.post(url, params, conf);
//  }
//};
const $skxhr = window.$sk.$skxhr; // 返回subject
const $skxhrp = window.$sk.$skxhrp;
export default {
  //--------表单页-------------
  //获取表单信息
  getCustomform: (info) => {
    return $skxhr("customForm/get", info);
  },
  //获取表单规则
  getCustomFormRules: (params) => {
    return $skxhr("api/customform/getRuleList", params);
  },
  //提交表单信息
  submitCustomform: (info) => {
    return $skxhr("customForm/action", info);
  },
  //获取抽奖
  getLuckydraw: (info) => {
    return $skxhr("luckyDraw/get", info);
  },
  // 获取线上会信息
  //getWebinar: (info) => {
  //  return $skxhr("api/webinar/get", info);
  //},
  // 获取服务器时间
  //getServerTime: (info) => {
  //  return $skxhr("webinar/open/getServerTime", info);
  //},
  // 获取验证码
  sendCheckCode: (info) => {
    return $skxhr("customForm/sendCheckCode", info);
  },

  // 检查自定义表单是否重复
  checkRegistration: (info) => {
    return $skxhr("customForm/checkRegistration", info);
  },
  // 检查手机号是否使用
  checkRepeatable: (info) => {
    return $skxhr("customForm/checkRepeatable", info);
  },

  // 获取线下会会议信息
  getTopicTemplateSeminar: (info) => {
    return $skxhrp("seminar/topicTemplate/seminar/get", info);
  },
  // 获取分会场信息
  getSubList: (info) => {
    return $skxhrp("seminar/register/getSubList", info);
  },
  //获取签到点数据接口
  getSignInPoint: (info) => {
    return $skxhrp("api/seminar/signingpoint/query", info);
  },
  //获取联系人的报名状态
  canRegisterNew: (info) => {
    return $skxhrp("seminar/register/canRegisterNew", info);
  },

  //浏览记录
  view: (info) => {
    return $skxhr("customForm/view", info);
  },
  browse: (info) => {
    return $skxhr("api/customform/browse", info);
  },
  lookup: (info) => {
    return $skxhr("member/LookUp", info);
  },
  getTemplateConfig: (info) => {
    return $skxhr("template/platform/instance/getConfig", info);
  },

  //获取实例ID所属模块和租户
  getChannel: (info) => {
    return $skxhr("account/channel/get", info);
  },

  //--------校验页-------------
  //webinarContactsGet: (info) => {
  //  return $skxhr("api/webinar/contacts/get", info);
  //},
  checkwithoutform: (info) => {
    return $skxhr("api/member/verify/code/checkwithoutform", info);
  },
  seminarGetsignupstatus: (info) => {
    return $skxhr("api/seminar/contacts/getsignupstatus", info);
  },
  webinarContactsLogin: (info) => {
    return $skxhr("api/webinar/contacts/login", info);
  },
  codeSendwithoutform: (info) => {
    return $skxhr("api/member/verify/code/sendwithoutform", info);
  },

  browseCategory: (info) => {
    return $skxhr("api/article/category/interaction/browse", info);
  },
  getConfig: (info) => {
    return $skxhr("template/template/getConfig", info);
  },
  // 检查推广链接状态
  checkTrackStatus: (info) => {
    return $skxhr("api/channel/track/info", info);
  },
};
